import { doc, getDoc } from 'firebase/firestore';

import { db } from 'services/firebase';

export const isUserAdmin = async (userId?: string): Promise<boolean> => {
  if (!userId) {
    return false;
  }

  const docSnap = await getDoc(doc(db, 'permissions/admin/users', userId));
  return docSnap.exists();
};

export const isUserVerified = async (userId?: string): Promise<boolean> => {
  if (!userId) {
    return false;
  }

  const docSnap = await getDoc(doc(db, 'permissions/verified/users', userId));
  return docSnap.exists();
};
